import { ShimmerTwoCol } from "./DashboardShimmer";
import "./dashboard-sections.css";

const DUMMY = {
  pallet: [
    { label: "Avg pallet wt paid",     value: "845.2 kg" },
    { label: "Avg orange pallet wt",   value: "822.4 kg" },
    { label: "Avg Pallet After Ripen", value: "814.8 kg" },
    { label: "Avg Peeler pallet wt",   value: "792.1 kg" },
  ],
  case: [
    { label: "Avg case wt paid",     value: "20.5 kg" },
    { label: "Avg case pallet wt",   value: "19.8 kg" },
    { label: "Avg case After Ripen", value: "19.4 kg" },
    { label: "Avg Peeler case wt",   value: "18.9 kg" },
  ],
};

const AvgCard = ({ title, rows }) => (
  <div className="db-avg-card">
    <div className="db-avg-header">
      <span className="db-avg-header-title">{title}</span>
      <span className="db-avg-header-icon">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <rect x="2" y="3" width="20" height="14" rx="2"/><line x1="8" y1="21" x2="16" y2="21"/><line x1="12" y1="17" x2="12" y2="21"/>
        </svg>
      </span>
    </div>
    {rows.map((r, i) => (
      <div key={i} className="db-avg-row">
        <span>{r.label}</span>
        <span className="db-avg-val">{r.value}</span>
      </div>
    ))}
  </div>
);

const AverageWeights = ({ data = DUMMY, isLoading = false }) => (
  <div>
    <div className="db-section-title">
      <span className="db-title-icon">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <circle cx="12" cy="5" r="3"/><path d="M6.5 8a2 2 0 0 0-1.905 1.46L2 17h20l-2.595-7.54A2 2 0 0 0 17.5 8z"/><line x1="12" y1="8" x2="12" y2="17"/>
        </svg>
      </span>
      Average Weights
    </div>
    {isLoading ? (
      <ShimmerTwoCol />
    ) : (
      <div className="db-two-col">
        <AvgCard title="Pallet Averages" rows={data.pallet} />
        <AvgCard title="Case Averages"   rows={data.case}   />
      </div>
    )}
  </div>
);

export default AverageWeights;
